<template>
  <page>
    <span slot="page-title">Data Dictionary</span>

    <v-data-table
      :headers="headers"
      :items="items"
      hide-actions>
      <template slot="items" slot-scope="{ item }">
        <tr :id="item.name.trim().toLowerCase().replace(/ /g, '-')">
          <td>{{ item.name }}</td>
          <!-- <td>{{ item.name }}</td> -->
          <td>{{ item.house }}</td>
          <td>{{ item.senate }}</td>
          <td>{{ item.update }}</td>
          <td>{{ item.factor }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.source }}</td>
          <td>{{ item.relation }}</td>
        </tr>
      </template>
    </v-data-table>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { Page } from '@/components'
import DataDictionary from '@/data_dictionary.json'

const name = 'data_dictionary'

const computed = {
  ...mapGetters({
    elections: 'elections/list'
  })
}

const components = {
  Page
}

export default {
  name,
  computed,
  components,
  metaInfo: {
    title: 'Data Dictionary'
  },
  data () {
    return {
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'House', value: 'house', sortable: true },
        { text: 'Senate', value: 'senate', sortable: true },
        { text: 'Update Frequency', value: 'update', sortable: true },
        { text: 'Factor Category', value: 'factor', sortable: true },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Relation to other variables', value: 'relation', sortable: false }
      ],
      items: DataDictionary
    }
  },
  mounted () {
    if (this.$route.hash) {
      const scrollToHash = () => {
        const elem = document.getElementById(this.$route.hash.slice(1))
        const headerHeight = document.getElementById('header').offsetHeight
        const top = elem.getBoundingClientRect().top - headerHeight
        window.scrollTo(0, top)
      }
      if (this.elections.length > 0) {
        scrollToHash()
      } else {
        const interval = setInterval(() => {
          if (this.elections.length > 0) {
            setTimeout(scrollToHash, 400)
            clearInterval(interval)
          }
        }, 200)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/DataDictionary.vue